import * as api from '../api';

export function isLanguageType(
  language: api.Language.LanguageWithOther,
): language is api.Language.Language {
  return (
    api.Language.languageMap[language] !== undefined && language !== 'OTHER'
  );
}
